export enum SupportedTokens {
  ENGI = 'ENGI',
  USDC = 'USDC',
}
